import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { setEditUser, updateUser } from '../../redux/actions/clients';
import Actions from '../Common/Actions';
import { useState } from 'react';
import Filters from '../Common/Filters';
import { useParams } from 'react-router';
import EditUser from './EditUser';
import { StoreState } from '../../types/state';
import { getLocalTime, timestampColumns } from '../../utils';

const ClientUsersList = ({ users }) => {
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();

  const timezone = useSelector((state: StoreState) => state.auth.timezone);
  const useLocalTime = timezone === 'UTC' ? false : true;

  const [filteredUsers, setFilteredUsers] = useState(users);

  const { editUser } = useSelector((state: StoreState) => ({
    editUser: state.clients.editUser,
  }));
  if (!users || users.length === 0) return <div>No Users</div>;

  return (
    <div>
      {editUser && <EditUser currentClientId={id} />}
      {users.length > 0 && (
        <Filters
          originalList={users}
          filteredLists={filteredUsers}
          allowedParams={[
            'UserName',
            'EMail',
            'IsActive',
            'IsAdmin',
            'ManagedProperties',
            'Roles',
          ]}
          setFilteredLists={setFilteredUsers}
        />
      )}
      <Table>
        <Table.Header>
          <Table.Row>
            {Object.keys(users[0])
              .concat('Actions')
              .map((header) => {
                return (
                  <Table.HeaderCell key={header}>{header}</Table.HeaderCell>
                );
              })}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {filteredUsers.map((user: any) => {
            return (
              <Table.Row key={user.id}>
                {Object.keys(user)
                  .map((elem: any) => {
                    return (
                      <Table.Cell key={`${elem}|${user.id}`}>
                        {timestampColumns.includes(elem) && useLocalTime
                          ? getLocalTime(user[elem])
                          : user[elem] === false
                          ? 'false'
                          : user[elem] && user[elem].toString()}
                      </Table.Cell>
                    );
                  })
                  .concat(
                    <Table.Cell key={`${user.id}-actions`}>
                      <Actions
                        showEdit
                        showEnable
                        isDisabled={!user.IsActive}
                        onDisable={() => {
                          dispatch(
                            updateUser({
                              data: {
                                ...user,
                                IsActive: !user.IsActive,
                              },
                              id,
                            })
                          );
                        }}
                        onEdit={() => {
                          dispatch(setEditUser(user));
                        }}
                      />
                    </Table.Cell>
                  )}
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
};

export default ClientUsersList;
